namespace GeniuzPOS.Purchase {
    export namespace PoCreditNoteAppService {
        export const baseUrl = 'Purchase/PoCreditNoteApp';

        export declare function Create(request: Serenity.SaveRequest<PoCreditNoteAppRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PoCreditNoteAppRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoCreditNoteAppRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoCreditNoteAppRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetNextNumber(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PoCreditNoteApp/Create",
            Update = "Purchase/PoCreditNoteApp/Update",
            Delete = "Purchase/PoCreditNoteApp/Delete",
            Retrieve = "Purchase/PoCreditNoteApp/Retrieve",
            List = "Purchase/PoCreditNoteApp/List",
            GetNextNumber = "Purchase/PoCreditNoteApp/GetNextNumber"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetNextNumber'
        ].forEach(x => {
            (<any>PoCreditNoteAppService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
